import { Grid } from "@mui/material";
import { grey } from "@mui/material/colors";

interface Props {
  children: React.ReactNode;
}

const CardWrapper = ({ children }: Props) => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      alignItems="stretch"
      item
      sx={{
        p: 3,
        border: `1px solid ${grey[200]}`,
        borderRadius: 4,
      }}
    >
      {children}
    </Grid>
  );
};

export default CardWrapper;
